import { useEffect } from 'react';

export function useHtmlClassObserver({ onChange }: { onChange: (className: string) => void }) {
  useEffect(() => {
    const htmlElement = document.documentElement;

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          onChange(htmlElement.className);
        }
      }
    });

    observer.observe(htmlElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, [onChange]);
}
